import React, { useCallback, useState } from "react";
import { SearchAddressInput, SearchAddressInputTypes } from "../SearchAddressInput/SearchAddressInput";
import { YandexMap } from "../MapComponent/YandexMap";
import { getCustomerFullAddress } from "../../utils/utils";
import { useCustomerAddressesStateData } from "../../providers/CustomerAddresses/CustomerAddressesStateContext";
import { useConfig } from "../../providers/config";
import { ParhatoAddressObject } from "@core/types";

interface ShippingAddressManuallyMapProps {
  setShowAddressForm: (newState: boolean) => void;
  inputWrapperItemStyles?: string;
}

const AddressSearchMap = ({ setShowAddressForm, inputWrapperItemStyles }: ShippingAddressManuallyMapProps) => {
  const { customerAddress, setCustomerAddress } = useCustomerAddressesStateData();
  const { headquarters } = useConfig();
  const onSetCustomerAddress = useCallback(
    (searchAddressResult: Partial<ParhatoAddressObject> | undefined) => {
      const [latitude, longitude] = searchAddressResult?.location || headquarters;
      setCustomerAddress({
        id: customerAddress?.id || "",
        city: searchAddressResult?.locality || "",
        house: searchAddressResult?.house || "",
        street: searchAddressResult?.street || "",
        latitude: String(latitude),
        longitude: String(longitude),
      });
    },
    [setCustomerAddress],
  );

  const showAddressForm = useCallback(() => {
    setShowAddressForm(true);
  }, [setShowAddressForm]);

  // When the "check" button is pressed, the address from the input disappears, and therefore it is done like this
  const [address, setAddress] = useState(
    customerAddress?.street ? getCustomerFullAddress(customerAddress, "for_YMap") : "",
  );

  const [userDraggingMap, setUserDraggingMap] = useState(false);

  const center =
    customerAddress?.latitude && customerAddress?.longitude
      ? [parseFloat(customerAddress.latitude), parseFloat(customerAddress.longitude)]
      : headquarters;

  return (
    <>
      <SearchAddressInput
        wrapperItemStyles={inputWrapperItemStyles}
        address={address}
        setUserDraggingMap={setUserDraggingMap}
        onOptionSelect={({ address }: SearchAddressInputTypes.SelectedOption) => {
          onSetCustomerAddress(address);
        }}
      />
      <div style={{ width: "100%", height: "88%", marginBottom: "3.125rem" }}>
        <YandexMap
          userDraggingMap={userDraggingMap}
          setUserDraggingMap={setUserDraggingMap}
          setAddress={setAddress}
          mapState={{
            center: center,
            zoom: 17,
          }}
          showAddressForm={showAddressForm}
          onSetCustomerAddress={(address) => onSetCustomerAddress(address)}
        />
      </div>
    </>
  );
};

export { AddressSearchMap };
